module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foot l_o_btm"
  }, [_c('div', {
    staticClass: "amount",
    on: {
      "touchstart": _vm.show_mx
    }
  }, [_vm._v(_vm._s(_vm.$t('book_amount')) + ":\n      "), _c('span', [_vm._v("￥" + _vm._s(_vm.getSumMoney()))]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-xia",
    attrs: {
      "id": "mx_angle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookbtn",
    on: {
      "click": _vm.book
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n    ")])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "mx_pop-book-footer",
    attrs: {
      "position": "bottom",
      "modal": false
    },
    model: {
      value: (_vm.mx_popupVisible),
      callback: function($$v) {
        _vm.mx_popupVisible = $$v
      },
      expression: "mx_popupVisible"
    }
  }, [_c('div', {
    staticClass: "mx-book-footer"
  }, [_c('div', {
    staticClass: "count"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('book_count')))]), _vm._v(" "), _c('div', {
    staticClass: "icon",
    on: {
      "touchstart": _vm.hide_mx
    }
  }, [_c('i', {
    staticClass: "iconfont icon-cuowu"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "mxList"
  }, _vm._l((_vm.bookingRsvSrcDto), function(item, index) {
    return (item.rmtype) ? _c('li', {
      key: 'bookingRsvSrcDto' + index,
      staticClass: "bookingRsvSrcDto"
    }, [_c('p', {
      staticClass: "room-name"
    }, [_vm._v(_vm._s(_vm.$t('book_rmtype')) + "：" + _vm._s(item.rmtype) + " "), (item.roomName) ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v("\n            " + _vm._s(item.roomName))]), _vm._v(" "), (item.rsvRates && item.rsvRates.length > 0) ? _vm._l((item.rsvRates), function(item2, index2) {
      return _c('div', {
        key: "rsvRates" + index2,
        staticClass: "everyDayRate"
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "40%"
        }
      }, [_vm._v(_vm._s(_vm._f("dateMD")(item2.d)))]), _vm._v(" "), (item2.privce != item2.realRate && item2.realRate != "") ? _c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "30%"
        }
      }, [_vm._v("\n                " + _vm._s(_vm.$t('book_origin_price')) + "：￥" + _vm._s(item2.privce) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline-block",
          "width": "30%",
          "text-align": "right"
        }
      }, [_c('span', [_vm._v("￥" + _vm._s(item2.realRate != '' ? item2.realRate : item2.privce) + " * " + _vm._s(item.rmnum))])])])
    }) : (item.everyDayRate && item.everyDayRate.list && item.everyDayRate.list.length > 0) ? _vm._l((item.everyDayRate.list), function(item2, index2) {
      return _c('div', {
        key: "everyDayRate" + index2,
        staticClass: "everyDayRate"
      }, [_c('span', [_vm._v(_vm._s(_vm._f("dateMD")(item2.d)))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("￥" + _vm._s(item2.privce) + " * " + _vm._s(item.rmnum))])])])
    }) : _vm._e()], 2) : _vm._e()
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e90aa04a","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/book/book-comp/bookFooter.vue
// module id = 1846
// module chunks = 107